module.exports = __webpack_public_path__ + "img/CRO-Melda- Maesarach.51b32455.jpg";